import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ToastService } from '../../Service/ToastService/toast.service';
import { FormStateService } from '../../module/service-provider/add-sp-new-component/form-state.service';
import { ServiceProviderService } from '../../Service/Service-providers/service-provider.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-distributors-sponsor-owner-details',
  templateUrl: './distributors-sponsor-owner-details.component.html',
  styleUrl: './distributors-sponsor-owner-details.component.scss'
})
export class DistributorsSponsorOwnerDetailsComponent {

  @Input() countryId!: string;
  form = new FormGroup({});
  // model: any = {};
  model: any = {
    ownerName: '',
    ownerPhoneNumber: '',
    ownerEmailAddress: '',
    IDProofofOwner: null,
    CVofestablishmentOwner: null,
    documents: [],
    address: '',
  };
  fields: FormlyFieldConfig[] = [];
  @Output() nextSection = new EventEmitter<void>();
  @Output() isValid = new EventEmitter<boolean>();
  @Output() onFinish = new EventEmitter<void>();
  @Output() closeDialog = new EventEmitter<void>();
  @Output() updateServiceDistributorList: EventEmitter<void> = new EventEmitter<void>();
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Input() idRecieved: any
  receivedObject: any;
  isFormPopulated = false;
  role: string = '';
  @Input() phoneNumber: any

  constructor(
    private formStateService: FormStateService,
    private api: ServiceProviderService,
    private cdr: ChangeDetectorRef,
    private formStateService1: FormStateService,
    private toast: ToastService,
    private router: Router,
  ) { }

  ngOnInit() {
    //this.role = this.formStateService1.getRole();
    // Subscribe to the form's validity changes
    this.form.statusChanges.subscribe(() => {
      this.isValid.emit(this.form.valid);
    });
    console.log('phoneNumber recieved in the owner details', this.phoneNumber)

    this.loadFormData();
    const tokenDetailsString = localStorage.getItem('user');
    if (tokenDetailsString) {
      const tokenDetails = JSON.parse(tokenDetailsString);
      this.countryId = tokenDetails.country?.countryId;
      this.model.countryId = this.countryId;
    }
    this.initializeFields();
  }

  ngOnDestroy() {
    this.saveFormData();
  }
  resetForm() {
    this.form.reset();
    this.model = {};
  }

  initializeFields() {
    this.fields = [
      {
        className: 'field col-12',
        // template: '<h3>Sponsor/Owner Information</h3>',
        //hideExpression: () => this.role !== 'distributor',
      },
      {
        fieldGroupClassName: 'p-fluid p-formgrid p-grid',
        fieldGroup: [

          {
            fieldGroupClassName: 'field grid p-fluid',
            fieldGroup: [
              {
                className: 'field col-6',
                key: 'ownerName',
                type: 'input',
                templateOptions: {
                  label: 'Name of the Sponsor/Owner',
                  placeholder: 'Enter Name',
                  required: true,
                  hideRequiredMarker: true,
                },

              },
              {
                className: 'field col-6',
                key: 'ownerEmailAddress',
                type: 'input',
                templateOptions: {
                  label: 'Email',
                  placeholder: 'Enter Email Id',
                  required: true,
                  hideRequiredMarker: true,
                  type: 'email',
                },
                validators: {
                  email: {
                    expression: (c: AbstractControl) =>
                      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                        c.value
                      ),
                    message: (error: any, field: FormlyFieldConfig) =>
                      `${field.formControl?.value} is not a valid email address`,
                  },

                },
              },
            ],
          },
          {
            template: `<div class="mt-1"></div>`,
          },
          {
            fieldGroupClassName: 'field grid p-fluid',
            fieldGroup: [
              {
                className: 'field col-6',
                key: 'ownerPhoneNumber',
                type: 'input',
                templateOptions: {
                  label: 'Phone Number',
                  placeholder: 'Enter Number',
                  type: 'tel',
                  required: true,
                  hideRequiredMarker: true,
                  maxLength: 10,
                },

              },
            ],
          },


          {
            className: 'field col-12',
            template: '<h3 class=" mt-5 mb-3">ID Proof of Owner</h3>',
          },
          {
            className: 'field col-12',
            key: 'IDProofofOwner',
            type: 'file',
            templateOptions: {
              placeholder: 'Upload',
              required: true,
              accept: '.pdf,.jpg,.png',
              description: 'Supported file formats: pdf, jpg, png',
              fileSourceId: 6,
            },
            validation: {
              messages: {
                required: () => 'Upload ID Proof of Owner.',
              },
            },

          },
          {
            className: 'field col-12',
            template: '<h3 class="mt-6 mb-3">CV of Establishment Owner </h3>',
          },
          {
            className: 'field col-12',
            key: 'CVofestablishmentOwner',
            type: 'file',
            templateOptions: {
              placeholder: 'Upload',
              required: true,
              accept: '.pdf,.jpg,.png',
              description: 'Supported file formats: pdf, jpg, png',
              fileSourceId: 6,
            },
            validation: {
              messages: {
                required: () => 'Upload CV of Establishment Owner.',
              },
            },

          },
        ],
      },
    ];
  }

  populateFormWithDistributorDetails(response: any) {
    if (!response) return;

    const documents = response.documents || [];

    const idProofDoc = documents.find((doc: any) => doc.documentTypeId === 7)?.fileId || null;
    const cvDoc = documents.find((doc: any) => doc.documentTypeId === 20)?.fileId || null;

    this.model = {
      ...this.model,
      ownerName: response.ownerName || '',
      ownerPhoneNumber: response.ownerPhoneNumber || '',
      ownerEmailAddress: response.ownerEmailAddress || '',
      IDProofofOwner: idProofDoc,
      CVofestablishmentOwner: cvDoc,
      documents: documents,
    };

    this.form.patchValue(this.model);

    console.log('Owner form patched with:', this.model);
    this.initializeFields()
  }


  loadFormData() {
    const savedData = this.formStateService.getFormData('owner-details');
    if (savedData) {
      this.model = savedData;
      this.form.patchValue(savedData);
    }
  }


  saveFormData() {
    //const formData = { ...this.model };
    //this.formStateService.setFormData('owner-details', formData);
    this.formStateService.setFormData('owner-details', this.model);
  }

  private updateDistributorBusinessInfo(data: any): Observable<any> {
    return this.api.postDistributorBusinessInfo(data);
  }

  private updateDistributorOwnerInfo(data: any): Observable<any> {
    return this.api.postDistributorOwnerInfo(data);
  }

  private updateDistributorDetailsFlow(): void {
    const updatedOwnerData = this.formStateService.getFormData('owner-details');
    const updatedBusinessData = this.formStateService.getFormData('business-details');
    const mapLocationData = this.formStateService1.getFormData('map-location');
    const address = updatedBusinessData.address || mapLocationData?.address || '';

    const transformedBusinessData = {
      ddistributorId: updatedBusinessData.distributorI,
      businessName: updatedBusinessData.businessName,
      phoneNumber: updatedBusinessData.phoneNumber || this.phoneNumber,
      businessTypeId: updatedBusinessData.businessTypeId,
      yearOfEstablishment: updatedBusinessData.yearOfEstablishment,
      commercialRegistrationNumber: updatedBusinessData.commercialRegistrationNumber,
      commercialRegistrationFileId: updatedBusinessData.CommercialRegistrationNumberId,
      address: address,
      city: updatedBusinessData.city,
      zip: updatedBusinessData.zip,
      countryId: this.countryId,
      stateId: updatedBusinessData.stateId,
      districtId: updatedBusinessData.districtId,
      gstNumber: updatedBusinessData.gstNumber,
      authorisedDelarshipProofUrl: updatedBusinessData.authorisedDelarshipProofUrl,
      website: updatedBusinessData.website,
      frontViewFileIds: updatedBusinessData.frontViewFileIds,
      distributorNetworks: (updatedBusinessData.distributorNetworks || []).map((network: any) => ({
        serviceProviderTypeId: network.serviceProviderTypeId,
        distributorNetworkSubType: (network.distributorNetworkSubType || []).map((sub: any) => ({
          serviceProviderSubTypeId: sub.serviceProviderSubTypeId,
          count: sub.count || 0
        }))
      })),
      certificateOfIncorporationFileId: updatedBusinessData.certificateOfIncorporation,
      insuranceOfDealershipFileId: updatedBusinessData.Insuranceofdealershipproof
    };

    console.log('Calling APIs with:');
    console.log('Business Info Payload:', transformedBusinessData);
    console.log('Owner Info:', updatedOwnerData);

    console.log('ADDRESSDETAILS:', updatedBusinessData.address);

    this.updateDistributorBusinessInfo(transformedBusinessData).subscribe({
      next: () => {
        this.toast.showToast('Business details updated.', 'success');

        // this.updateDistributorOwnerInfo(updatedOwnerData).subscribe({
        //   next: () => {
        //     this.toast.showToast('Owner details updated.', 'success');
        //     this.updateServiceDistributorList.emit();
        //     this.close.emit();
        //     this.onFinish.emit();
        //     this.cdr.detectChanges();
        //   },
        //   error: (err) => {
        //     console.error('Error updating owner details:', err);
        //     this.toast.showToast('Failed to update owner details.', 'error');
        //   }
        // });
        this.updateDistributorOwnerInfo(updatedOwnerData).subscribe({
          next: (response) => {
            if (response?.isSuccess) {
              this.toast.showToast('Owner details updated.', 'success');
              this.updateServiceDistributorList.emit();
              this.close.emit();
              this.onFinish.emit();
            } else {
              const errorMessage = response?.errors?.length
                ? response.errors.join(', ')
                : 'Failed to update owner details. Please try again.';
              this.toast.showToast(errorMessage, 'error');
            }
            this.cdr.detectChanges();
          },
          error: (err) => {
            console.error('Error updating owner details:', err);
            this.toast.showToast('Failed to update owner details.', 'error');
          }
        });
      },
      error: (err) => {
        console.error('Error updating business details:', err);
        this.toast.showToast('Failed to update business details.', 'error');
      }
    });
  }
  submit() {
    if (!this.form.valid) return;

    const ownerDetails = this.transformOwnerData(this.form.value);

    if (this.idRecieved) {
      const formData = {
        ...(this.form.value || this.model),
        distributorId: this.idRecieved,
      };
      this.formStateService.setFormData('owner-details', formData);
      const ownerFormData = {
        ...(this.formStateService.getFormData('owner-details') || {}),
        distributorId: this.idRecieved,
        phoneNumber: this.phoneNumber,
      };
      this.formStateService.setFormData('owner-details', ownerFormData);

      const businessFormData = {
        ...(this.formStateService.getFormData('business-details') || {}),
        distributorId: this.idRecieved,
        address: '',
        phoneNumber: this.phoneNumber
      };
      this.formStateService.setFormData('business-details', businessFormData);

      this.updateDistributorDetailsFlow();
    } else {
      this.formStateService.setOwnerInchargeDetails(ownerDetails);
      const finalPayload = this.formStateService.getCombinedDataForDistributor();
      if (!finalPayload.address) {
        finalPayload.address = '';
      }
      console.log('Payload before calling the api', finalPayload);

      this.api.submitDistributorDetails(finalPayload).subscribe({
        next: (response) => {
          console.log('Distributor Submission Response:', response);
          if (response?.isSuccess) {
            this.toast.showToast('Distributor registered successfully!', 'success');
            this.updateServiceDistributorList.emit();
            this.close.emit();
            this.onFinish.emit();
          } else {
            const errorMessage = response?.errors?.length
              ? response.errors.join(', ')
              : 'Failed to register distributor. Please try again.';
            this.toast.showToast(errorMessage, 'error');
          }
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('HTTP/network error occurred:', error);
          this.toast.showToast('Something went wrong. Please try again later.', 'error');
        }
      });
    }
  }
  transformOwnerData(formData: any): any {
    return {
      ownerName: formData.ownerName,
      ownerEmailAddress: formData.ownerEmailAddress,
      ownerPhoneNumber: formData.ownerPhoneNumber,
      documents: [
        {
          documentTypeId: 7,
          fileId: formData.IDProofofOwner
        },
        {
          documentTypeId: 20,
          fileId: formData.CVofestablishmentOwner
        }
      ]
    };
  }
}
